import { useParams } from 'react-router-dom';

export const useRoomId = () => {
  const { projectId = '' } = useParams<{ projectId: string }>();

  return projectId;
};
